import * as React from 'react';

import Form from './partials/Form';

import Layout from '../../../../shared/Layout';

import NavigationProp from '../../../../../navigators/NavigationProp';
import {NewSceneFormBackgroundShowSceneCommandNewBackgroundRouteProp} from '../../../../../navigators/RouteProps';

import {Params as BackgroundUsageHistoryUpdateParams} from '../../../../../actions/background_usage_histories/update';
import {Params as SceneFormUpdateParams} from '../../../../../actions/scene_forms/update';
import {Params as CoachmarkModalUpdateParams} from '../../../../../actions/coachmark_modal/update';

import CoachmarkState from '../../../../../view_models/CoachmarkState';

import redirectSceneForm from '../../../../../helpers/redirectSceneForm';

import BackgroundUsageHistory from '../../../../../../domain/entities/BackgroundUsageHistory';
import SceneForm from '../../../../../../domain/forms/SceneForm';

import File from '../../../../../../domain/entities/File';

import NetBackgroundsRepository from '../../../../../../data/repositories/writer/NetBackgroundsRepository';

export interface Params {
  storyId: number;
  episodeId?: number;
  sceneId?: number;
}

export interface StateProps {
  navigation: NavigationProp;
  route: NewSceneFormBackgroundShowSceneCommandNewBackgroundRouteProp;
  sceneForm: SceneForm | null;
  coachmarkModal: CoachmarkState | null;
}

export interface DispatchProps {
  updateBackgroundUsageHistory: (
    id: number,
    params: BackgroundUsageHistoryUpdateParams,
  ) => Promise<BackgroundUsageHistory>;
  updateSceneForm: (params: SceneFormUpdateParams) => Promise<SceneForm>;
  updateCoachmarkModal: (params: CoachmarkModalUpdateParams) => void;
}

interface Props extends StateProps, DispatchProps {}

const New: React.FC<Props> = props => {
  const {
    navigation,
    route,
    sceneForm,
    updateBackgroundUsageHistory,
    coachmarkModal,
    updateSceneForm,
    updateCoachmarkModal,
  } = props;
  React.useEffect(() => {
    if (redirectSceneForm(navigation, route, sceneForm)) {
      return;
    }
  }, []);

  const [image, setImage] = React.useState<File | null>(null);
  const [submitting, setSubmitting] = React.useState(false);
  const onChangeImage = React.useCallback((file: File) => {
    setImage(file);
  }, []);
  const onRequestReset = React.useCallback(() => {
    setImage(null);
  }, []);
  const onSubmit = React.useCallback((file: File) => {
    const repository = new NetBackgroundsRepository();
    const params = {
      background: {
        image: file,
        name: file.name,
        story_id: route.params.storyId,
      },
    };
    setSubmitting(true);
    repository
      .create(params, {multipart: true})
      .then(background => {
        if (!background) {
          return;
        }
        if (!sceneForm) {
          return;
        }
        const id = sceneForm.id;
        const storyId = sceneForm.storyId;
        const episodeId = sceneForm.episodeId;
        const options = {};
        const params = {id, background, storyId, episodeId, options};
        if (coachmarkModal === 'first_episode_form_created') {
          updateCoachmarkModal({value: 'first_episode_form_background_done'});
        }
        updateSceneForm(params);
        updateBackgroundUsageHistory(background.id, {storyId}).then(() => {
          (navigation.getParent() || navigation).goBack();
        });
      })
      .catch(() => {
        setSubmitting(false);
      });
  }, []);
  return (
    <Layout
      title={'背景アップロード'}
      scrollable={false}
      back={true}
      navigation={navigation}
      close={true}>
      <Form
        image={image}
        submitting={submitting}
        onChangeImage={onChangeImage}
        onSubmit={onSubmit}
        onRequestReset={onRequestReset}
      />
    </Layout>
  );
};

export default New;
